import { Paper, Typography, Grid, Skeleton } from '@mui/material';

export const DynamicProfilingQuestionSkeleton = () => {
    return (
        <Paper sx={{ p: 4, mt: 2, mb: 2 }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        <Skeleton sx={{ width: ['100%', '380px'] }} />
                    </Typography>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        <Skeleton sx={{ width: ['100%', '220px'] }} />
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Skeleton height={50} sx={{ mb: 2 }} />
                    <Skeleton height={50} sx={{ mb: 2 }} />
                    <Skeleton height={50} />
                </Grid>
            </Grid>
        </Paper>
    );
};
